import * as React from "react";
import { withCookies } from "react-cookie";
import { connect } from "react-redux";
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UserDucks from "stores/ducks/User.duck";


/**
 * Checks for the presence of a user cookie and sets it to the redux state along with some more data
 * retrieved from the server.
 */
class AppAuth extends React.PureComponent<{ cookies?: any; dispatch: any }> {
  public componentDidMount() {
    // If user is logged in then 
    if (this.props.cookies.get("user")) {
      const userCookie = this.props.cookies.get("user");
      if (userCookie.token && userCookie.id) {
        fetchGraphQL(
          `query {
            user {
              getRelatedEvents(userId:"${userCookie.id}") 
            }
          }
          `
        ).then(res => {
          const events = {};
          JSON.parse(res.user.getRelatedEvents).events.forEach((item, index) => {
            events[String(index)] = item;
          })
          const user = {
            ...userCookie,
            events
          }
          this.props.dispatch(UserDucks.setUser(user));
        })
      }
    }
  }

  public render() {
    return null;
  }

}

const mapStateToProps = state => {
  return {
    isLoggedin: UserDucks.isAuthenticated(state)
  };
};

export default withCookies(connect(mapStateToProps)(AppAuth));



// WEBPACK FOOTER //
// ./src/components/app/AppAuth.tsx